import { useRecoilValue } from 'recoil'
import useSWR from 'swr'
import { Api } from '../api'
import { touristTokenState } from '../store/tourist'
import { userState } from '../store/user'

const useGet = <T>(
  key: Parameters<typeof useSWR>[0],
  { isPublic = false, memberAuth = false, cache = true } = {}
) => {
  const touristToken = useRecoilValue(touristTokenState)
  const user = useRecoilValue(userState)
  return useSWR<T>(
    (isPublic ? true : touristToken || user) && key,
    memberAuth ? (uri, data) => Api.get(uri, data, { memberAuth }) as T : null,
    {
      revalidateIfStale: !cache,
    }
  )
}

export { useGet }
